(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rescript-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rs-slider]').forEach((slider)=>{if(slider.dataset.ready)return;slider.dataset.ready='true';const slides=[...slider.querySelectorAll('[data-rs-slide]')];const dots=[...slider.querySelectorAll('[data-rs-dot]')];let index=0;const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index))};slider.querySelector('[data-rs-prev]')?.addEventListener('click',()=>show(index-1));slider.querySelector('[data-rs-next]')?.addEventListener('click',()=>show(index+1));dots.forEach((dot)=>dot.addEventListener('click',()=>show(Number(dot.dataset.rsDot))))})

  } catch(e) { console.error(e); }
})();
})();
